export const ROOT = 'common/logout';

export const FETCH_LOGOUT_REQUEST = `${ROOT}/FETCH_LOGOUT_REQUEST`;
export const FETCH_LOGOUT_FAILURE = `${ROOT}/FETCH_LOGOUT_FAILURE`;
export const FETCH_LOGOUT_SUCCESS = `${ROOT}/FETCH_LOGOUT_SUCCESS`;

export const SET_LOGOUT_VALUE = `${ROOT}/SET_LOGOUT_VALUE`;